/**
 * Which loading indicator the 3D panel shows, on the plot panel's model
 * (`PlotLoadingState`). `"foreground"` blocks the whole panel with a large
 * spinner. `"background"` puts a small one in the header and leaves the scene
 * usable. `false` shows neither.
 */
export type ThreeDLoadingState = "foreground" | "background" | false;

/**
 * Picks the panel's loading indicator.
 *
 * A scene that is still getting ready blocks the panel, since there is nothing
 * to look at yet. Entity data that is loading earns only the header indicator:
 * whatever has loaded stays on screen and usable. A panel that failed to render
 * shows its error instead of either.
 */
export function threeDLoadingState({
  sceneLoading,
  dataLoading,
  failed,
}: {
  /** The manager has not yet reported its scene ready. */
  sceneLoading: boolean;
  /** Some entity's data is being fetched. */
  dataLoading: boolean;
  /** The panel could not render at all. */
  failed: boolean;
}): ThreeDLoadingState {
  if (failed) {
    return false;
  }
  if (sceneLoading) {
    return "foreground";
  }
  return dataLoading ? "background" : false;
}
